import { useSearchParams } from "react-router-dom";

/**
 * Tab state mirrored into a URL search param so the active tab survives a
 * refresh and can be shared as a link. The default value keeps the URL clean
 * (param removed); switching replaces the history entry instead of pushing.
 * Distinct keys let independent tab groups coexist on one page.
 */
export const useTabParam = (key: string, defaultValue: string) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const value = searchParams.get(key) ?? defaultValue;
  const setValue = (v: string) =>
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        if (v === defaultValue) next.delete(key);
        else next.set(key, v);
        return next;
      },
      { replace: true }
    );
  return [value, setValue] as const;
};
